(function() {
    const apiBaseUrl = 'https://wonderent.wonderchef.com/api';
    const GUEST_CART_KEY = 'wr-guest-cart';
    let lastAddedItem = JSON.parse(localStorage.getItem('lastAddedItem')) || null;
  
  //  console.log('Last added item:', lastAddedItem);
  
    function showMessage(message, isError = false) {
      const messageElement = document.getElementById('cart-message') || createMessageElement();
      messageElement.textContent = message;
      messageElement.className = isError ? 'error-message' : 'info-message';
      messageElement.style.display = 'block';
      setTimeout(() => messageElement.style.display = 'none', 5000);
    }
  
    function createMessageElement() {
      const messageElement = document.createElement('div');
      messageElement.id = 'cart-message';
      messageElement.style.padding = '10px';
      messageElement.style.margin = '10px 0';
      messageElement.style.borderRadius = '5px';
      document.querySelector('.rental-cart-container').prepend(messageElement);
      return messageElement;
    }
  
    function formatMoney(amount) {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(amount);
    }
  
    function setLoading(isLoading) {
      const loadingOverlay = document.getElementById('loading-overlay');
      if (loadingOverlay) {
        loadingOverlay.style.display = isLoading ? 'flex' : 'none';
      }
    }
  
    async function apiCall(endpoint, method = 'GET', body = null) {
      setLoading(true);
      const requestId = Math.random().toString(36).substring(7);
    //  console.group(`API Call ${requestId} to ${endpoint}`);
    //  console.log('Request details:', {
    //    method,
    //    endpoint,
    //    body,
    //    cookies: document.cookie,
    //    sessionId: getCookie('sessionid'),
    //    csrfToken: getCookie('csrftoken')
    //  });
  
      try {
        const headers = new Headers({
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        });
  
        // Log all cookies
        const cookies = document.cookie.split(';').reduce((acc, cookie) => {
          const [key, value] = cookie.trim().split('=');
          acc[key] = value;
          return acc;
        }, {});
    //    console.log('Available cookies:', cookies);
  
        const options = {
          method,
          headers,
          credentials: 'include',
          mode: 'cors'
        };
  
        if (body) {
          options.body = JSON.stringify({
            ...body,
            session_key: getCookie('sessionid'),
            request_id: requestId
          });
        }
  
    //    console.log('Making fetch request with options:', {
    //      url: `${apiBaseUrl}/${endpoint}`,
    //      options: {
    //        ...options,
    //        headers: Object.fromEntries(headers)
    //      }
    //    });
  
        const response = await fetch(`${apiBaseUrl}/${endpoint}`, options);
    //    console.log('Response received:', {
    //      status: response.status,
    //      statusText: response.statusText,
    //      headers: Object.fromEntries(response.headers)
    //    });
  
        if (!response.ok) {
          const errorText = await response.text();
        //  console.error('Error response body:', errorText);
          throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
        }
  
        const data = await response.json();
    //    console.log('Success response:', data);
        return data;
      } catch (error) {
        //  console.error('Detailed error information:', {
        //    name: error.name,
        //    message: error.message,
        //    stack: error.stack,
        //    requestId,
        //    endpoint,
        //    method,
        //    body
        //  });
        throw error;
      } finally {
        //  console.groupEnd();
        setLoading(false);
      }
    }
  
    async function createNewCart() {
      try {
        const response = await apiCall('create-rental-cart/', 'POST');
        //  console.log('Create new cart response:', response);
        return response;
      } catch (error) {
        //  console.error('Error creating new cart:', error);
        throw error;
      }
    }
  
    async function fetchRentalCart() {
        //  console.log('Fetching rental cart...');
      
      if (isGuestUser()) {
        console.log('Fetching guest cart from localStorage');
          const guestCart = getGuestCart();
          return {
              cart_items: guestCart.items,
              is_guest: true
          };
      }
  
        //  console.log('Fetching cart for logged-in user');
      try {
          const response = await fetch(`${apiBaseUrl}/get-rental-cart/`, {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
              },
              credentials: 'include'
          });
  
          if (!response.ok) {
            //  console.error('Failed to fetch cart:', response.status, response.statusText);
              const errorText = await response.text();
            //  console.error('Error response:', errorText);
              throw new Error(`Failed to fetch cart: ${response.status}`);
          }
  
          const cartData = await response.json();
        //  console.log('Cart data from API:', cartData);
          return cartData;
      } catch (error) {
        //  console.error('Error fetching rental cart:', error);
          return { cart_items: [] };
      }
    }
  
    async function getProductImageByVariant(variantId) {
      try {
          const csrfToken = getCookie('csrftoken');
          const response = await fetch(`${apiBaseUrl}/get-product-image/${variantId}/`, {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json',
                  'X-CSRFToken': csrfToken,
                  'X-Requested-With': 'XMLHttpRequest'
              },
              credentials: 'include'
          });
          
          if (response.ok) {
              const data = await response.json();
            //  console.log('Product image data:', data);
              return data.image_url;
          }
        //  console.error('Failed to fetch image:', response.status, response.statusText);
          return null;
      } catch (error) {
        //  console.error('Error fetching product image:', error);
          return null;
      }
    }
  
    async function renderRentalCart(cartData) {
        //  console.log('Rendering cart with data:', cartData);
      const rentalCartContainer = document.querySelector('.rental-cart-container');
  
      if (!rentalCartContainer) {
        //  console.error('Cart container not found!');
          return;
      }
  
      // Ensure cart_items exists and is an array
      const items = cartData?.cart_items || [];
      const isGuest = cartData?.is_guest || isGuestUser();
  
      if (items.length === 0) {
        //  console.log('Cart is empty');
          rentalCartContainer.innerHTML = `
              <p>Your rental cart is empty.</p>
              ${isGuest ? `<p class="guest-cart-notice">You are shopping as a guest. <a href="${window.loginUrl}">Login</a> to save your cart.</p>` : ''}
          `;
          return;
      }
  
      // Add guest cart notice if applicable
      if (isGuest) {
          const noticeDiv = document.createElement('div');
          noticeDiv.className = 'guest-cart-notice';
            noticeDiv.innerHTML = 'You are shopping as a guest. <a href="/account/login">Login</a> to save your cart.';
          rentalCartContainer.prepend(noticeDiv);
      }
  
      // Calculate totals (for guest cart)
      const totals = isGuestUser() ? calculateGuestCartTotals(cartData.cart_items) : {
        total_rent: cartData.total || 0,
        security_deposit: cartData.cart_items.reduce((sum, item) => sum + (item.security_deposit || 0), 0)
      };
  
      let html = '';
      html += '<div class="rental-cart-layout">';
      html += '<div class="rental-cart-items">';
      html += '<div class="rental-cart-header"><span>PRODUCT</span></div>';
  
      // Convert forEach to for...of to use async/await
      for (const item of cartData.cart_items) {
        //  console.log('Processing cart item:', item);
          
          // Get image URL using variant ID
          const imageUrl = await getProductImageByVariant(item.variant_id);
        //  console.log(`Image URL for ${item.name}:`, imageUrl);
  
          html += `
              <div class="rental-cart-item">
                  <div class="rental-cart-item-image">
                      <img 
                          src="${imageUrl || 'https://via.placeholder.com/100'}" 
                          alt="${item.name}"
                          onerror="this.onerror=null; this.src='https://via.placeholder.com/100';"
                      >
                  </div>
                  <div class="rental-cart-item-details">
                      <h3>${item.name}</h3>
                      <div class="rental-item-info">
                          <div class="rental-item-tenure">
                              <label for="rental-period-${item.id}" class="small-label">Tenure</label>
                              <select id="rental-period-${item.id}" onchange="window.rentalCart.updateRentalPeriod(${item.id}, this.value)">
                                  ${['1 Month', '3 Months', '6 Months', '9 Months', '12 Months']
                                      .filter(period => {
                                          const months = period.split(' ')[0];
                                          console.log('Debug tenure filter:', { product: item.name, period, months, enabled_periods: item.enabled_rental_periods });
                                          if (!item.enabled_rental_periods) {
                                              // Default: show only 3, 6, 12 months if enabled_rental_periods not set
                                              const allowed = ['3', '6', '12'];
                                              const result = allowed.includes(months);
                                              console.log('No enabled_periods set, default filter result:', result);
                                              return result;
                                          }
                                          const result = item.enabled_rental_periods[`m${months}`] !== false;
                                          console.log('Filter result for period:', period, result);
                                          return result;
                                      })
                                      .map(period => `
                                          <option value="${period}" ${item.rental_period === period ? 'selected' : ''}>
                                              ${period}
                                          </option>
                                      `).join('')}
                              </select>
                          </div>
                          <div class="rental-item-rent">
                              <span>Rent per month:</span>
                              <span class="price">${formatMoney(item.emi)}</span>
                          </div>
                          <div class="rental-item-total">
                              <span>Total rent for ${item.rental_period}:</span>
                              <span class="price">${formatMoney(item.total)}</span>
                          </div>
                          <div class="rental-item-payment">
                              <span>Refundable security deposit:</span>
                              <span class="price">${formatMoney(item.security_deposit)}</span>
                          </div>
                      </div>
                      <div class="rental-item-actions">
                          <div class="rental-item-quantity">
                              <label for="quantity-${item.id}" class="small-label">Quantity</label>
                              <div class="quantity-input">
                                  <button class="quantity-btn minus" onclick="window.rentalCart.updateCartItemQuantity(${item.id}, ${item.quantity - 1})">-</button>
                                  <input type="number" id="quantity-${item.id}" min="1" value="${item.quantity}" 
                                      onchange="window.rentalCart.updateCartItemQuantity(${item.id}, this.value)">
                                  <button class="quantity-btn plus" onclick="window.rentalCart.updateCartItemQuantity(${item.id}, ${item.quantity + 1})">+</button>
                              </div>
                          </div>
                          <div class="button-group">
                              <button class="remove-btn" onclick="window.rentalCart.removeCartItem(${item.id})">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                      <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/>
                                  </svg>
                              </button>
                          </div>
                      </div>
                  </div>
              </div>
          `;
      }
  
      html += '</div>'; // Close rental-cart-items
  
      html += '<div class="order-summary">';
      html += '<h2>ORDER SUMMARY</h2>';
      html += '<div class="summary-items">';
      
      html += `
          <div class="summary-item">
              <span>Total Rent</span>
              <span class="prices">${formatMoney(totals.total_rent)}</span>
          </div>
          <div class="summary-item">
              <span>Security Deposit</span>
              <span class="prices">${formatMoney(totals.security_deposit)}</span>
          </div>
          <div class="summary-item">
              <span>Delivery</span>
              <span><del>₹99</del>    ₹0</span>
          </div>
          <div class="summary-item total">
              <span>Total Amount</span>
              <span class="total-prices">${formatMoney(totals.total_rent + totals.security_deposit)}</span>
          </div>
      `;
  
      html += '</div>'; // Close summary-items
      
      html += `
          <div class="terms-conditions">
              <input type="checkbox" id="terms-checkbox" required>
              <label for="terms-checkbox">I accept the <a href="/pages/wonderent-terms-of-use" target="_blank">Terms & Conditions</a>*</label>
              <div class="error-message" id="terms-error" style="display: none; color: red; font-size: 12px;">Please accept the Terms & Conditions</div>
          </div>
          <button id="rental-checkout-button" class="checkout-btn">CHECKOUT NOW</button>
      `;
  
      html += '</div>'; // Close order-summary
      html += '</div>'; // Close rental-cart-layout
  
      rentalCartContainer.innerHTML = html;
  
      // Re-attach event listener for checkout button
      document.getElementById('rental-checkout-button').addEventListener('click', proceedToCheckout);
    }
  
    async function updateRentalPeriod(itemId, newPeriod) {
        //  console.log('Updating rental period:', { itemId, newPeriod });
      try {
          if (isGuestUser()) {
              const guestCart = getGuestCart();
              const itemIndex = guestCart.items.findIndex(item => item.id === parseInt(itemId));
              
              if (itemIndex !== -1) {
                  // Extract the number from the period string (e.g., "3 Months" -> 3)
                  const months = parseInt(newPeriod);
                  guestCart.items[itemIndex].rental_period = newPeriod;
                  guestCart.items[itemIndex].total = guestCart.items[itemIndex].emi * months;
                  
                  saveGuestCart(guestCart);
                  await renderRentalCart({ cart_items: guestCart.items, is_guest: true });
                  showMessage('Rental period updated', false);
              }
          } else {
              const cartData = await apiCall('update-rental-period/', 'POST', {
                  item_id: itemId,
                  rental_period: newPeriod
              });
              
              // Only proceed if we have valid cart data with items
              if (cartData && cartData.cart_items && cartData.cart_items.length > 0) {
                  await renderRentalCart(cartData);
                  showMessage('Rental period updated successfully', false);
              } else {
                  // If no valid cart data, fetch fresh cart data
                  const freshCartData = await fetchRentalCart();
                  if (freshCartData && freshCartData.cart_items) {
                      await renderRentalCart(freshCartData);
                      showMessage('Rental period updated successfully', false);
                  } else {
                      // If still no valid data, reload the page
                      window.location.reload();
                  }
              }
          }
      } catch (error) {
        //  console.error('Error updating rental period:', error);
          showMessage('Failed to update rental period', true);
      }
    }
  
    async function updateCartItemQuantity(itemId, newQuantity) {
      try {
          if (isGuestUser()) {
              const result = await handleGuestCartOperation('update_quantity', itemId, { quantity: newQuantity });
              if (result) {
                  await renderRentalCart({ cart_items: result.cart_items, is_guest: true });
                  showMessage('Cart updated successfully', false);
              }
          } else {
              const cartData = await apiCall('adjust-cart-item-quantity/', 'POST', {
                  item_id: itemId,
                  quantity: newQuantity
              });
              if (cartData) {
                  await renderRentalCart(cartData);
                  showMessage('Cart updated successfully', false);
              }
          }
      } catch (error) {
        console.error('Error updating cart item quantity:', error);
          showMessage('Failed to update cart', true);
      }
    }
  
    async function removeCartItem(itemId) {
        //  console.log('Removing cart item:', itemId);
      try {
          if (isGuestUser()) {
              const guestCart = getGuestCart();
              const itemIndex = guestCart.items.findIndex(item => item.id === parseInt(itemId));
              
              if (itemIndex !== -1) {
                  guestCart.items.splice(itemIndex, 1);
                  saveGuestCart(guestCart);
                  await renderRentalCart({ cart_items: guestCart.items, is_guest: true });
                  showMessage('Item removed from cart', false);
              }
          } else {
              const cartData = await apiCall('remove-cart-item/', 'POST', { 
                  item_id: itemId 
              });
              
              // Only proceed if we have valid cart data with items
              if (cartData && cartData.cart_items && cartData.cart_items.length > 0) {
                  await renderRentalCart(cartData);
                  showMessage('Item removed from cart', false);
              } else {
                  // If no valid cart data, fetch fresh cart data
                  const freshCartData = await fetchRentalCart();
                  if (freshCartData && freshCartData.cart_items) {
                      await renderRentalCart(freshCartData);
                      showMessage('Item removed from cart', false);
                  } else {
                      // If still no valid data, reload the page
                      window.location.reload();
                  }
              }
          }
      } catch (error) {
        //  console.error('Error removing cart item:', error);
          showMessage('Failed to remove item from cart', true);
      }
    }
  
    async function refreshCart() {
        showMessage('Refreshing cart...', false);
      const cartData = await fetchRentalCart();
      if (cartData) {
        renderRentalCart(cartData);
        showMessage('Cart refreshed successfully', false);
      }
    }
  
    async function proceedToCheckout() {
      try {
          const termsCheckbox = document.getElementById('terms-checkbox');
          const termsError = document.getElementById('terms-error');
          
          if (!termsCheckbox || !termsCheckbox.checked) {
              termsError.style.display = 'block';
              return;
          }
          termsError.style.display = 'none';
  
          setLoading(true);
  
          // Get cart data based on user status
          const cartData = await fetchRentalCart();
          if (!cartData || !cartData.cart_items || cartData.cart_items.length === 0) {
              showMessage('Your cart appears to be empty. Please add items before proceeding to checkout.', true);
              return;
          }
  
          if (isGuestUser()) {
              // Use the new customer authentication path
              window.location.href = "/customer_authentication/login?return_to=%2Fpages%2Frental-cart";
              return;
          }
  
          // Proceed with normal checkout for logged-in users
          const prepareResponse = await apiCall('prepare-checkout/', 'POST', {
              customer_email: window.customer?.email,
              cart_items: cartData.cart_items
          });
  
          if (prepareResponse.success) {
              window.location.href = '/pages/rental-checkout';
          } else {
              showMessage(prepareResponse.error || 'Failed to prepare checkout', true);
          }
      } catch (error) {
        //  console.error('Error proceeding to checkout:', error);
          showMessage('Failed to proceed to checkout. Please try again.', true);
      } finally {
          setLoading(false);
      }
    }
    
    // Create a global object to expose necessary functions and data
    window.rentalCart = {
      updateRentalPeriod,
      updateCartItemQuantity,
      removeCartItem,
      refreshCart,
      proceedToCheckout,
      apiBaseUrl
    };
  
    // Initialize the rental cart when the DOM is fully loaded
    function initializeRentalCart() {
        console.log('Initializing rental cart...');
      
      const MAX_RETRIES = 50; // 5 seconds maximum wait
      let retryCount = 0;
      
      const checkAuthAndFetchCart = async () => {
        //  console.log('Checking auth state...', retryCount);
        //  console.log('Auth instance:', window.wrAuthInstance);
        //  console.log('Auth state:', window.wrAuthInstance?.stateBridge?.state);
  
          // Wait for WrAuth to initialize
          if (!window.wrAuthInstance && retryCount < MAX_RETRIES) {
            //  console.log('Waiting for WrAuth to initialize...');
              retryCount++;
              setTimeout(checkAuthAndFetchCart, 100);
              return;
          }
  
          // Once WrAuth is available
          if (window.wrAuthInstance) {
              const isLoggedIn = window.wrAuthInstance.stateBridge.state.shopifyCustomer;
            //  console.log('WrAuth initialized, user logged in:', !!isLoggedIn);
  
              if (isLoggedIn) {
                  // For logged-in users, wait for session validation
                  if (window.wrAuthInstance.stateBridge.state.session?.validated) {
                    //  console.log('Session validated, fetching cart...');
                      const cartData = await fetchRentalCart();
                    //  console.log('Logged-in user cart data:', cartData);
                      await renderRentalCart(cartData);
                  } else if (retryCount < MAX_RETRIES) {
                    //  console.log('Waiting for session validation...');
                      retryCount++;
                      setTimeout(checkAuthAndFetchCart, 100);
                      return;
                  }
              } else {
                  // Guest user flow
                  //  console.log('Guest user detected, fetching guest cart...');
                  const cartData = await fetchRentalCart();
                  //  console.log('Guest cart data:', cartData);
                  await renderRentalCart(cartData);
              }
          } else {
              // If max retries reached, fall back to guest cart
              //  console.log('Max retries reached, falling back to guest cart');
              const cartData = await fetchRentalCart();
              await renderRentalCart(cartData);
          }
      };
  
      // Start checking once DOM is loaded
      if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', checkAuthAndFetchCart);
      } else {
          checkAuthAndFetchCart();
      }
    }
  
    // Initialize cart with proper timing
    document.addEventListener('DOMContentLoaded', () => {
        //  console.log('DOM loaded, waiting for WrAuth...');
      // Wait a bit for WrAuth to initialize
      setTimeout(initializeRentalCart, 500);
    });
  
    function injectStyles() {
      const styleElement = document.createElement('style');
      styleElement.textContent = `
        .rental-cart-container {
          font-family: Arial, sans-serif;
          max-width: 1200px;
          margin: 0 auto;
        }
  
     
  
        .rental-cart-layout {
          display: flex;
          gap: 20px;
        }
  
        .rental-cart-items {
          flex: 2;
        }
  
        .rental-cart-header {
          background-color: #f5f5f5;
          padding: 10px;
          font-weight: bold;
        }
  
        .rental-cart-item {
          display: flex;
          border-bottom: 1px solid #e0e0e0;
          padding: 20px 0;
        }
  
        .rental-cart-item-image {
          width: 100px;
          margin-right: 20px;
        }
  
        .rental-cart-item-image img {
          max-width: 100%;
          height: auto;
        }
  
        .rental-cart-item-details {
          flex: 1;
        }
  
        .rental-cart-item-details h3 {
          margin-top: 0;
          margin-bottom: 10px;
        }
  
        .rental-item-info {
          display: flex;
          gap: 20px;
          margin-bottom: 15px;
        }
  
        .small-label {
          font-size: 12px;
          color: #666;
          margin-bottom: 4px;
          display: block;
        }
  
        .rental-item-tenure,
        .rental-item-rent,
        .rental-item-total,
        .rental-item-payment,
        .rental-item-quantity {
          display: flex;
          flex-direction: column;
          color: grey;
        }
  
        .rental-item-tenure select,
        .quantity-input {
          height: 30px;
        }
  
        .rental-item-tenure select {
          padding: 0 5px;
        }
  
        .rental-item-actions {
          display: flex;
          align-items: flex-end;
          gap: 10px;
        }
  
        .quantity-input {
          display: flex;
          border: 1px solid #e0e0e0;
        }
  
        .quantity-btn {
          background: none;
          border: none;
          width: 30px;
          height: 30px;
          font-size: 18px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
        }
  
        .quantity-btn:hover {
          background-color: #f0f0f0;
        }
  
        .quantity-input input {
          width: 40px;
          text-align: center;
          border: none;
          border-left: 1px solid #e0e0e0;
          border-right: 1px solid #e0e0e0;
          padding: 5px;
          -moz-appearance: textfield;
        }
  
        .quantity-input input::-webkit-outer-spin-button,
        .quantity-input input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
  
        .button-group {
          display: flex;
          gap: 5px;
        }
  
        .update-btn, .remove-btn {
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
  
        .order-summary {
          flex: 1;
          padding: 20px;
        }
  
        .order-summary h2 {
          margin-top: 0;
        }
  
        .summary-items {
          margin-bottom: 20px;
        }
  
        .summary-item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
        }
  
        .summary-item.total {
          font-weight: bold;
        }
  
        .summary-item.total .price {
          color: #d32f2f;
          font-weight: bold;
        }
  
        .price {
          color: #d32f2f;
        }
  
        .terms-conditions {
          margin-bottom: 20px;
        }
  
        .checkout-btn {
          width: 100%;
          background-color: #d32f2f;
          color: white;
          border: none;
          padding: 10px;
          cursor: pointer;
          text-transform: uppercase;
        }
  
        .rental-item-quantity {
          display: flex;
          align-items: center;
          gap: 10px;
        }
  
        .quantity-input {
          display: flex;
          border: 1px solid #e0e0e0;
        }
  
        .quantity-btn {
          background: none;
          border: none;
          width: 30px;
          height: 30px;
          font-size: 18px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
        }
  
        .rental-item-rent .price,
        .rental-item-total .price,
        .rental-item-payment span {
          font-weight: bold;
        }
  
        .update-btn, .remove-btn {
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: white;
          border: 1px solid #d32f2f;
          color: #d32f2f;
          cursor: pointer;
          transition: all 0.3s ease;
        }
  
        .update-btn {
          padding: 0 15px;
          text-transform: uppercase;
          font-size: 14px;
        }
  
        .remove-btn {
          width: 30px;
          font-size: 18px;
        }
  
        .update-btn:hover, .remove-btn:hover {
          background-color: #d32f2f;
          color: white;
        }
  
        .guest-cart-notice {
          background-color: #fff3cd;
          color: #856404;
          padding: 10px;
          margin-bottom: 15px;
          border-radius: 4px;
          text-align: center;
        }
        .guest-cart-notice a {
          color: #856404;
          text-decoration: underline;
        }
      `;
      document.head.appendChild(styleElement);
    }
  
    function getCookie(name) {
      let cookieValue = null;
      if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();
          if (cookie.substring(0, name.length + 1) === (name + '=')) {
            cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
            break;
          }
        }
      }
      return cookieValue;
    }
  
    // Add guest cart utility functions
    function getGuestCart() {
      try {
          const cart = JSON.parse(localStorage.getItem(GUEST_CART_KEY) || '{"items":[]}');
        //  console.log('Retrieved guest cart:', cart);
          return cart;
      } catch (error) {
        //  console.error('Error parsing guest cart:', error);
          return { items: [] };
      }
    }
  
    function saveGuestCart(cart) {
      try {
        //  console.log('Saving guest cart:', cart);
          localStorage.setItem(GUEST_CART_KEY, JSON.stringify(cart));
          return true;
      } catch (error) {
        //  console.error('Error saving guest cart:', error);
          return false;
      }
    }
  
    function isGuestUser() {
      return !isUserLoggedIn();
    }
  
    // Add guest cart operations
    async function handleGuestCartOperation(operation, itemId, data = {}) {
      const cart = getGuestCart();
      const itemIndex = cart.items.findIndex(item => item.id === itemId);
      
      switch (operation) {
          case 'update_quantity':
              if (itemIndex !== -1 && data.quantity > 0) {
                  cart.items[itemIndex].quantity = parseInt(data.quantity);
              }
              break;
          case 'update_period':
              if (itemIndex !== -1) {
                  cart.items[itemIndex].rental_period = data.rental_period;
                  // Recalculate totals if needed
              }
              break;
          case 'remove':
              if (itemIndex !== -1) {
                  cart.items.splice(itemIndex, 1);
              }
              break;
      }
  
      saveGuestCart(cart);
      return { cart_items: cart.items };
    }
  
    // Add calculateGuestCartTotals helper
    function calculateGuestCartTotals(cartItems) {
      return cartItems.reduce((totals, item) => {
        totals.total_rent += (item.total * item.quantity) || 0;
        totals.security_deposit += (item.security_deposit * item.quantity) || 0;
        return totals;
      }, { total_rent: 0, security_deposit: 0 });
    }
  
    // Add listener for cart updates after merge
    window.addEventListener('cartUpdated', async (event) => {
        //  console.log('Cart updated event received:', event.detail);
      if (event.detail?.cart) {
        await renderRentalCart(event.detail.cart);
      }
    });
  
    // Add helper function to check login status
    function isUserLoggedIn() {
      return !!window.wrAuthInstance?.stateBridge?.state?.shopifyCustomer;
    }
  })();